// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@awc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { userListUsersTableStyles } from "@awc/Overrides/Widgets/UserList/UserListUsersTable";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

userListUsersTableStyles.noResultsContainer = {
    ...dataTableStyles.noResultsContainer,
};

userListUsersTableStyles.lastSignInHeader = userListUsersTableStyles.lastSignInCells = {
    css: css`
        text-align: left;
    `,
};

userListUsersTableStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

userListUsersTableStyles.usernameCells = {
    css: css`
        ${xScreen("lte", "sm")} {
            text-align: left;
        }
    `,
};

userListUsersTableStyles.dataTableRow = {
    css: css`
        font-size: 14px;
        line-height: 19px;
        ${xScreen("lte", "sm")} {
            font-size: 12px;
            line-height: 17px;
        }
    `,
};

userListUsersTableStyles.pagination = {
    mergeCss: true,
    cssOverrides: {
        pagination: css`
            ${xScreen("lte", "md")} {
                justify-content: space-between;
            }
        `,
        perPageSelect: css`
            && {
                width: auto;
            }
        `,
        linkList: css`
            && {
                width: auto;
            }
        `,
    },
};

userListUsersTableStyles.countText = {
    forwardAs: "p",
    color: "primary",
    size: fontConfig.fontSize.singleLineRegular,
    lineHeight: fontConfig.lineHeight.small,
    css: css`
        margin-bottom: 12px;
    `,
};
